import React from 'react'
import MaterialSymbol from '../material-symbol'

const Save = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="save" {...props} />
))

Save.displayName = 'Save'

export default Save
